import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useProgramCategories } from './useProgramCategories';
import { setCategories } from '../context/programCategoriesSlice';

export const useCreateProgramsTreeData = () => {
    const [myArray, setArray] = useState([]);

    const branch = useSelector((state) => state.adminProgram.branch)
    const { programCategories } = useProgramCategories('/AdminProgramsTreeMulti/' + branch)

    const dispatch = useDispatch()
    dispatch(setCategories(programCategories))
    
    useEffect(() => {
        const updateArray = (id, parent, droppable, text, idx) => {
            const newItem = {
                id: id,
                parent: parent,
                droppable: droppable,
                text: text,
                data: {
                    idx: idx
                }
            };
            setArray(prevArray => [...prevArray, newItem]);
        };

        programCategories && programCategories.map(category => {
            updateArray(category.id, 0, true, category.name)
            category.adminPrograms && category.adminPrograms.map(prog => {
                updateArray(prog.id, category.id, true, prog.programName)
                prog.exercises && prog.exercises.map(exercise => {
                    updateArray(exercise.id, prog.id, false, exercise.name, exercise.idx)
                    return null
                })
                return null
            })
            return null
        })

         // Clean up function
        return () => {
            setArray([]); // Reset the array when the component unmounts
        };
    }, [programCategories]);

    return { myArray, setArray };
};
